import styled, { css } from 'styled-components'
import { desktopBreakpoint, SolidButton, wideScreenBreakpoint } from 'react-components'
import { LAYOUT } from '../../../../../constants/search-result-listing'

/**
 * Uses CSS native `position: sticky` behavior.
 * Placed inside LeftColumn (flex column), it will sit below the main sidebar
 * and become sticky when it hits the top offset.
 */
export const StickyPopularContainer = styled.aside<{ isVisible: boolean }>`
    display: none;
    width: ${LAYOUT.SMALL_SIDEBAR_WIDTH}rem;
    flex-direction: column;
    background-color: ${({ theme }) => theme.colors.white};
    border-radius: 12px;
    padding: 1rem;
    border: 1px solid #0000001a;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    z-index: 90;

    /* Native sticky positioning */
    position: sticky;
    top: calc(${LAYOUT.HEADER_HEIGHT}rem + ${LAYOUT.STICKY_GAP}rem);
    margin-top: 1rem;

    /* Visibility control */
    opacity: ${({ isVisible }) => (isVisible ? 1 : 0)};
    pointer-events: ${({ isVisible }) => (isVisible ? 'auto' : 'none')};
    transition: opacity 0.2s ease;

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: flex;
    }

    @media only screen and (min-width: ${wideScreenBreakpoint.min}px) {
        width: ${LAYOUT.SIDEBAR_WIDTH}rem;
    }
`

export const StickyTitle = styled.h3`
    font-size: 0.875rem;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.tfwBlack87};
    margin-bottom: 1rem;
`

export const FilterWrapper = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;

    .filter-content {
        min-width: unset !important;
    }
`

export const SubmitButton = styled(SolidButton)<{ disabled?: boolean }>(
    ({ disabled, theme }) => css`
        width: 100%;
        display: flex;
        justify-content: center;
        padding: ${theme.spacing.xSmall} ${theme.spacing.medium};
        margin-top: 0.5rem;

        ${disabled &&
        css`
            pointer-events: none;
            cursor: not-allowed;
            opacity: 0.5;
        `};
    `,
)

export const BackToTopButton = styled(SolidButton)`
    width: 100%;
    display: flex;
    justify-content: center;
    padding: ${({ theme }) => `${theme.spacing.xSmall} ${theme.spacing.medium}`};
    margin-top: 0.5rem;
    border: 1px solid ${props => props.theme.colors.tfwBlack99};
    background-color: ${({ theme }) => theme.colors.white};

    &:hover {
        background-color: ${({ theme }) => theme.colors.white};
    }
`

export const ButtonText = styled.strong`
    text-align: center;
    font: ${({ theme }) => `${theme.typography.font.weight.bold} ${theme.typography.font.size.small} /
        ${theme.typography.font.size.xLarge} ${theme.typography.font.family.latoVerdana}`};
`

export const MapWidgetContainer = styled.div`
    position: relative;
    top: 0;
    width: 100%;
    height: ${LAYOUT.MAP_HEIGHT}rem;
    border-radius: 12px;
    overflow: hidden;
    background-color: #f7f7f7;
    display: none;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    border: none;
    flex-shrink: 0;
    z-index: 1;
    margin-bottom: 1rem;

    &:hover {
        opacity: 0.95;
    }

    @media only screen and (min-width: ${desktopBreakpoint.min}px) {
        display: flex;
    }
`
